"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestIds = exports.ARIA_LABEL_DEFAULT = exports.ARIA_LABEL_KEY = exports.ARIA_LABEL_NAMESPACE = void 0;
exports.ARIA_LABEL_NAMESPACE = 'ariaLabels';
exports.ARIA_LABEL_KEY = 'interactions_AriaLabel_contentOnHover_message';
exports.ARIA_LABEL_DEFAULT = 'Interactive element, focus to trigger content change';
exports.TestIds = {
    BG: 'container-bg',
};
//# sourceMappingURL=constants.js.map